export const DEFAULT_1 = "I'm not working with anyone yet";
export const DEFAULT_2 = "I'm working with someone";

export const agents = [
  {
    title: DEFAULT_1,
    id: DEFAULT_1,
  },
];
